import { render, staticRenderFns } from "./InvoiceSelect.vue?vue&type=template&id=58b196a6&scoped=true"
import script from "./InvoiceSelect.vue?vue&type=script&lang=js"
export * from "./InvoiceSelect.vue?vue&type=script&lang=js"
import style0 from "./InvoiceSelect.vue?vue&type=style&index=0&id=58b196a6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58b196a6",
  null
  
)

export default component.exports